<template>
  <div>
    <b-row>
      <b-col cols="4">
        <b-form-group
          id="input-group-1"
          :label="numtitle"
          label-for="input-1"
          label-size="default"
          label-cols-sm="3"
          label-cols-lg="4"
        >
          <b-form-input
            id="input-1"
            v-model="answer.head"
            type="email"
            required
            placeholder="정답제목"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-input
          id="input-1"
          v-model="answer.body"
          required
          placeholder="정답을 작성하세요"
        ></b-form-input>
      </b-col>
      <b-col cols="1">
        <b-button variant="danger" @click="del">D</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <b-input-group>
            <b-form-input
              id="input-1"
              v-model="intent"
              type="email"
              required
              placeholder="출제포인트"
            ></b-form-input>
            <b-input-group-append>
              <b-button size="sm" text="Button" variant="info">찾기</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ["answer"],
  data() {
    return {
      intent: "",
    };
  },
  computed: {
    numtitle() {
      return "정답" + this.answer.num;
    },
  },
  methods: {
    del() {
      this.$store.dispatch("removeAnswer", this.answer);
    },
  },
};
</script>


<style lang="scss" scoped>
</style>